import $ from 'jquery';
import './vendor/jquery.waypoints.min.js';
import './vendor/jquery.hoverintent.min.js';
import './vendor/jquery.easing.min.js';

/************************
* ANCHORED SUBNAVIGATION
*************************/
function anchoredSubnavSetup() {
    import('./vendor/jquery.sticky.js').then(() => {
        $('.cl-anchored-subnav').each(function() {
            var subnav = $(this);
            subnav.sticky({topSpacing:0, zIndex: '10000'});
        });
    });
    var dimensions = getViewportDimensions();
    var offset = (dimensions['w'] < 768) ? 50 : 80;

    var anchoredSubnavWaypoints = [];
    $('.cl-anchored-subnav-section').each(function() {
        var section = $(this);
        var element = $(section.find('.cl-anchored-subnav-section-link').attr('href'))[0];
        if (element) {
            anchoredSubnavWaypoints.push(new Waypoint({
                element: element,
                handler: function(direction) {
                    $('.cl-anchored-subnav-section').removeClass('active');
                    if(direction == "down") {
                        section.addClass('active');
                    } else {
                        section.prev().addClass('active');
                    }
                },
                offset: offset
            }));
        }
    });
}

function getViewportDimensions() {
    var dimensions = new Array();
    dimensions['w'] = $(window).width();
    dimensions['h'] = $(window).height();
    return dimensions;
}

function anchoredSubnavSmoothScrollSetup() {
    var dimensions = getViewportDimensions();

    $('.cl-anchored-subnav-section-link').on('click', function(e){
        e.preventDefault();
        var offset = (dimensions['w'] < 768) ? 50 : 80;
        var element = $(this).attr('href');
        if (element) {
            $('html, body').animate({
                scrollTop: $(element).offset().top - offset + 20
            }, 1000);
        }
    });
}

function anchoredSubnavMobileShareButton() {
    $('.cl-anchored-subnav-share-open-link').on('click', function(e){
        $('.cl-anchored-subnav .cl-anchored-subnav-share .cl-anchored-subnav-share-list-container').addClass('open');
        e.preventDefault();
    });
    $('.cl-anchored-subnav-share-list-item.close .cl-anchored-subnav-share-list-item-link').on('click', function(e){
        $('.cl-anchored-subnav .cl-anchored-subnav-share .cl-anchored-subnav-share-list-container').removeClass('open');
        e.preventDefault();
    });
}

if($('.cl-anchored-subnav').length > 0 && window.location.pathname != '/styleguide/') {
    anchoredSubnavSetup();
    anchoredSubnavSmoothScrollSetup();
    anchoredSubnavMobileShareButton();
}

/************************
 * EVENT CARD
 *************************/
function expandEventCard(jQuerythis, width) {
    if(width >= 768) {
        $('.cl-event-card').addClass('faded');
        jQuerythis.parents('.cl-event-card-container').css('height', jQuerythis.parents('.cl-event-card').height());
    }
    jQuerythis.parents('.cl-event-card').removeClass('faded').addClass('open');
    jQuerythis.find('.cl-event-card-more-content-container').slideDown({
        duration: 400,
        easing: 'easeOutCubic'});
}

function collapseEventCard(jQuerythis) {
    jQuerythis.find('.cl-event-card-more-content-container').slideUp({
        duration: 400,
        easing: 'easeOutCubic',
        complete: function () {
            jQuerythis.parents('.cl-event-card').removeClass('open');
            jQuerythis.parents('.cl-event-card-container').css('height', 'auto');
        }
    });
    $('.cl-event-card').removeClass('faded');
}


function eventCardSetup() {

    $('.cl-event-card-more')
        .unbind('mouseenter')
        .unbind('mouseleave')
        .off('click')
        .removeProp('hoverIntent_t')
        .removeProp('hoverIntent_s');

    var dimensions = getViewportDimensions();

    if(dimensions['w'] >= 768) {
        $('.cl-event-card-more').hoverIntent(function () {
            expandEventCard($(this), dimensions['w']);
        },
        function () {
            collapseEventCard($(this))
        });
    } else {
        $('.cl-event-card-more').on('click', function() {
            if($(this).parents('.cl-event-card').hasClass('open')) {
                collapseEventCard($(this));
            } else {
                expandEventCard($(this), dimensions['w']);
            }
        });
    }
}

if($('.cl-event-card').length > 0) {
    eventCardSetup();

    $(window).resize(function() {
        eventCardSetup();
    });
}

/************************
 * SOCIAL SHARE
 *************************/
function socialShareSetup() {
    var facebookLinkPrefix = 'http://www.facebook.com/sharer/sharer.php?u=';
    var twitterLinkPrefix = 'http://twitter.com/share?url=';
    var linkedinLinkPrefix = 'https://www.linkedin.com/shareArticle?mini=true&url=';

    var facebookLinkPostfix = '&title=';
    var twitterLinkPostfix = '&text=';
    var linkedinLinkPostfix = '&title=';

    var pageURL = window.location.href;
    var pageTitle = $(document).find("title").text();

    var facebookLink = facebookLinkPrefix + pageURL + facebookLinkPostfix + pageTitle;
    var twitterLink = twitterLinkPrefix + pageURL + twitterLinkPostfix + pageTitle;
    var linkedinLink = linkedinLinkPrefix + pageURL + linkedinLinkPostfix + pageTitle;

    $('.cl-social-sharing').each(function(){
        $(this).find('.facebook a').attr('href', facebookLink);
        $(this).find('.twitter a').attr('href', twitterLink);
        $(this).find('.linkedin a').attr('href', linkedinLink);
    });
}

if($('.cl-social-sharing').length > 0) {
    socialShareSetup();
}

/************************
 * DISQUS
 *************************/
function disqusSetup() {
    $('.cl-disqus').each(function(){
        $(this).prepend('<div id="disqus_thread"></div>');

        var scriptTag = $('<script></script>');

        var script = "";
        script += "var disqus_config = function () {";
        script += "this.page.url = 'https://cablelabs.com" + window.location.pathname + "';";

        var slug = window.location.pathname.split('/');
        slug = slug[slug.length - 2];
        console.log(slug);
        script += "this.page.identifier = '" + slug + "';";
        script += "};";

        script += "(function() {";
        script += "var d = document, s = d.createElement('script');";
        script += "s.src = '//cablelabs.disqus.com/embed.js';";
        script += "s.setAttribute('data-timestamp', +new Date());";
        script += "(d.head || d.body).appendChild(s);";
        script += "})();";

        scriptTag.text(script);

        $(this).append(scriptTag);
    });
}

if($('.cl-disqus').length > 0) {
    disqusSetup();
}

/************************
 * Table of Contents
 *************************/
function tableOfContentsSetup() {
    $('.cl-table-of-contents').each(function(){
        var $this = $(this);
        $(this).find('li').on('click', function(){
            $this.find('li').removeClass('active');
            $(this).addClass('active');
        })
    });
}

if($('.cl-table-of-contents').length > 0) {
    tableOfContentsSetup();
}
